// import anime from "animejs";


(function($) {
  var header = $(".header");

  $(".header-mobile__trigger").click(function() {
    $(".menu-tendina").toggleClass("menu-tendina--active");
    $(".hamburger").toggleClass("is-active");

    // Blocca/sblocca lo scroll del sito quando il menu è aperto/chiuso
    $('body').toggleClass('no-scroll');

    // Chiudi tutti i submenu se il menu principale viene chiuso
    if (!$(".menu-tendina").hasClass("menu-tendina--active")) {
      // Assumi che `closeAllSubmenus` sia definita nel tuo script JavaScript precedente
      closeAllSubmenus(); // Chiama questa funzione per chiudere tutti i submenu
      $('body').removeClass('no-scroll'); // Assicurati che lo scroll sia riabilitato quando il menu viene chiuso
    }

  });



  // Header follow
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    // if (scroll >= $(window).height()) {
    //   header.addClass("active-scroll");
    // } else {
    //   header.removeClass("active-scroll");
    // }

    if (scroll >= 35) {
      header.addClass("header--scroll");
      $('.header-mobile__trigger').addClass('header-mobile__trigger--scroll');
    } else {
      header.removeClass("header--scroll");
      $('.header-mobile__trigger').removeClass('header-mobile__trigger--scroll');
    }
  });

})(jQuery);





document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.menu-links li');
  const menuImages = document.querySelectorAll('.menu-image');

  menuItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
          const menuId = this.dataset.menuId;
          
          menuImages.forEach(image => {
              if (image.dataset.menuId === menuId) {
                  image.classList.add('opacity-100');
                  image.classList.remove('opacity-0');
              } else {
                  image.classList.remove('opacity-100');
                  image.classList.add('opacity-0');
              }
          });
      });
  });
});